import { useMemo } from "react"

export function useRandomIndex(length: number, lastSeenIndex: number | null) {
  return useMemo(function () {
    if (length < 2) return 0

    let newIndex = Math.floor(Math.random() * length)
    while (newIndex === lastSeenIndex) {
      newIndex = Math.floor(Math.random() * length)
    }
    return newIndex
  }, [])
}
